var _defs, _rect, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg10021IconServiceVirtualMachine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fd454f1c-5506-44b8-874e-8814b8b2f70b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f34d9569-2bd0-4002-8f16-3d01d8106cb5",
    x1: 8.88,
    y1: 12.21,
    x2: 8.88,
    y2: 0.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5ea0ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bdb45a0b-eb58-4970-a60a-fb2ce314f866",
    x1: 8.88,
    y1: 16.84,
    x2: 8.88,
    y2: 12.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707070"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-compute-21") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.12,
    y: 0.21,
    width: 18,
    height: 12,
    rx: 0.6,
    fill: "url(#f34d9569-2bd0-4002-8f16-3d01d8106cb5)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "11.88 4.46 11.88 7.95 8.88 9.71 8.88 6.21 11.88 4.46",
    fill: "#50e6ff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "11.88 4.46 8.88 6.22 5.88 4.46 8.88 2.71 11.88 4.46",
    fill: "#c3f1ff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "8.88 6.22 8.88 9.71 5.88 7.95 5.88 4.46 8.88 6.22",
    fill: "#9cebff"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "5.88 7.95 8.88 6.21 8.88 9.71 5.88 7.95",
    fill: "#c3f1ff"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "11.88 7.95 8.88 6.21 8.88 9.71 11.88 7.95",
    fill: "#9cebff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.49,15.84c-1.78-.28-1.85-1.56-1.85-3.63H7.11c0,2.07-.06,3.35-1.84,3.63a1,1,0,0,0-.89,1h9A1,1,0,0,0,12.49,15.84Z",
    fill: "url(#bdb45a0b-eb58-4970-a60a-fb2ce314f866)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10021IconServiceVirtualMachine);
export default __webpack_public_path__ + "static/media/10021-icon-service-Virtual-Machine.93e633eccf3f4e1d9a0630dce7401f29.svg";
export { ForwardRef as ReactComponent };